/* eslint-disable */
export const obterTipoMensagem = function(idxTipo) {
  const tipo = { motivo: '', descricaoMotivo: '' };

  let descricaoMotivoDefesaExtraordinaria = 'O pagador está fora dos prazos legais para apresentar uma defesa, portanto é facultado ao recebedor analisar esta defesa.'; 
  descricaoMotivoDefesaExtraordinaria += 'Caso não responda, prevalecerá o último estado pago/não pago, antes da primeira mensagem extraordinária.';

  let descricaoMotivoContestacaoExtraordinaria = 'O recebedor está fora dos prazos legais para apresentar uma contestação, portanto é facultado ao pagador responder a esta contestação.';
  descricaoMotivoContestacaoExtraordinaria += 'Caso não responda, prevalecerá o último estado pago/não pago, antes da primeira mensagem extraordinária.';

  switch (idxTipo) {
    case 1:
      tipo.motivo = 'Nenhum valor recebido';
      tipo.descricaoMotivo = 'O recebedor não identificou nenhum valor depositado.';
      break;
    case 2:
      tipo.motivo = 'Valor recebido incorreto';
      tipo.descricaoMotivo = 'O recebedor identificou um valor diferente do calculado pelo Comprev.';
      break;
    case 3:
      tipo.motivo = 'Valor pago corretamento dentro do prazo';
      tipo.descricaoMotivo = 'O Pagador informou que a transação bancária foi realizada com o valor correto dentro do prazo.';
      break;
    case 4:
      tipo.motivo = 'Valor pago após o vencimento (em atraso)';
      tipo.descricaoMotivo = 'O Pagador informou que a transação bancária foi realizada após a data de vencimento com o valor acrescido dos juros e multa devidos.';
      break;
    case 5:
      tipo.motivo = 'Valor foi rejeitado pela instituição financeira';
      tipo.descricaoMotivo = 'O Pagador informou que a transação bancária foi rejeitada por diverências nos dados bancários.';
      break;
    case 6:
      tipo.motivo = 'Pagamento aprovado';
      tipo.descricaoMotivo = 'O recebedor aprovou a defesa do pagamento';
      tipo.msgSistema = 'Pagamento aprovado automaticamente por perda de prazo de análise.'
      break;
    case 7:
      tipo.motivo = 'Confirmação do valor rejeitado';
      tipo.descricaoMotivo = 'O recebedor confirmou que as informações bancárias deste pagamento estão incorretas impossibilitando o pagamento.';
      tipo.msgSistema = 'Confirmação de pagamento rejeitado automaticamente por perda de prazo de análise.'
      break;
    case 8:
      tipo.motivo = 'Pagamento reprovado';
      tipo.descricaoMotivo = 'O recebedor reprovou a defesa do pagamento';
      tipo.msgSistema = 'Pagamento reprovado automaticamente por perda de prazo de defesa.';
      break;
    case 9:
      tipo.motivo = 'Defesa de regularidade do pagamento';
      tipo.descricaoMotivo = 'Defesa de regularidade do pagamento';
      tipo.msgSistema = 'Defesa de regularidade do pagamento.';
      break;
    case 10:
      tipo.motivo = 'Defesa de regularidade do pagamento aprovada';
      tipo.descricaoMotivo = 'Defesa de regularidade do pagamento aprovada';
      tipo.msgSistema = 'Defesa de regularidade do pagamento aprovada.';
      break;
    case 11:
      tipo.motivo = 'Defesa de regularidade do pagamento reprovada';
      tipo.descricaoMotivo = 'Defesa de regularidade do pagamento reprovada';
      tipo.msgSistema = 'Defesa de regularidade do pagamento reprovada.';
      break;
    case 12:
      tipo.motivo = 'Defesa do pagamento da GRU';
      tipo.descricaoMotivo = 'Comprovação de pagamento da GRU ';
      tipo.msgSistema = 'Comprovação de pagamento da GRU .';
    break; 
    case 13:
      tipo.motivo = 'Defesa do pagamento de GRU';
      tipo.descricaoMotivo = 'Pagamento aprovado';
      tipo.msgSistema = 'Defesa de regularidade do pagamento da GRU aprovada.';
      break; 
    case 14:
      tipo.motivo = 'Defesa do pagamento de GRU';
      tipo.descricaoMotivo = 'Pagamento reprovado';
      tipo.msgSistema = 'Defesa de regularidade do pagamento da GRU reprovada.';
      break; 
    case 15:
      tipo.motivo = 'Defesa extraordinária';
      tipo.descricaoMotivo = descricaoMotivoDefesaExtraordinaria;
      tipo.msgSistema = '';
      break;
    case 16:
      tipo.motivo = 'Contestação Extraordinária';
      tipo.descricaoMotivo = descricaoMotivoContestacaoExtraordinaria;
      tipo.msgSistema = '';
      break;   
    default:
      tipo.motivo = 'Mensagem desconhecida';
      tipo.descricaoMotivo = '';
  }
  return tipo;
};



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/tiposMensagens.js